import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username } from '../internal.js'

const credentialTypes = [username, password, accountNumber] as const

export type ancfCredType = (typeof credentialTypes)[number]
export const ancfDocumentTypes = [
  'delivery-photo',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const ancf: CarrierDef<ancfCredType> = {
  name: 'Alliance Air Freight & Logistics',
  scac: 'ancf',
  credentialTypes,
  engineLayers: ['documents', 'pickup', 'rating', 'tracking'],
  documentTypes: ancfDocumentTypes,
  ltlServices: [
    { id: 'standard', name: 'Deferred' },
    { id: 'threshold', name: 'Threshold Delivery' },
  ],
}
